export function nonNull<T>(arg: T | null | undefined): arg is T {
	return arg != null;
}
